import { render, staticRenderFns } from "./initialFormOfNote.vue?vue&type=template&id=3b00011e&"
import script from "./initialFormOfNote.vue?vue&type=script&lang=js&"
export * from "./initialFormOfNote.vue?vue&type=script&lang=js&"
import style0 from "./initialFormOfNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports